/** 送迎パターンのクラス。 */
export default class PickupPattern {
  /** お迎え先→空港（＝空港着）の場合の設定値。 */
  static readonly TO_AIRPORT = 1;

  /** 空港→お送り先（＝空港発）の場合の設定値。 */
  static readonly FROM_AIRPORT = 2;

  /** 往復の場合の設定値。 */
  // 2021/07/07現在未使用。
  static readonly ROUND_TRIP = 3;

  /**
   * 送迎パターンが空港着であるかを判別する。
   * @param v
   */
  static isToAirport(v: number) {
    return v === PickupPattern.TO_AIRPORT;
  }
}
